import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface SummaryTileProps {
  label: ReactNode;
  value: ReactNode;
  unit?: ReactNode;
  sub?: ReactNode;
  tone?: 'default' | 'bad' | 'warn' | 'good' | undefined;
  className?: string | undefined;
}

/** KPI tile from the dashboard summary strip and the job to-date header. */
export function SummaryTile({
  label,
  value,
  unit,
  sub,
  tone = 'default',
  className,
}: SummaryTileProps) {
  return (
    <div
      className={cn(
        'min-w-0 rounded-xl border border-line2 bg-surface px-3.5 py-3 shadow-card',
        className,
      )}
    >
      <div className="eyebrow overflow-hidden text-ellipsis whitespace-nowrap">{label}</div>
      <div
        className={cn(
          'mt-0.5 flex items-baseline gap-1.5 text-2xl leading-tight font-extrabold num',
          tone === 'bad' && 'text-bad',
          tone === 'warn' && 'text-warn',
          tone === 'good' && 'text-good',
        )}
      >
        {value}
        {unit ? <small className="text-[13px] font-semibold text-ink3">{unit}</small> : null}
      </div>
      {sub ? <div className="mt-0.5 text-xs text-ink3">{sub}</div> : null}
    </div>
  );
}
